import "./navbar.css";
import { useEffect, useState } from "react";
import picture12 from "../../picture/12.png";
import picture13 from "../../picture/13.png";
import picture0 from "../../picture/14.png";
import picture1 from "../../picture/15.png";
import picture2 from "../../picture/16.png";
import { useGlobalContext } from "../../../Context/Context";
import CustomButton from "./CustomButton";
import ShowBar from "../Showbar/showBar";
import WraperCustom from "../wraperCustom/WraperCustom";
import Settings from "../settings/Settings";
import SelectedNavbar from "./SelectedNavbar";
import Button from "../../Custom/Button/Button";
import axios from "axios";
import { data } from "../addLocation/data";
import backImg from "../../picture/Back.png";
import arrowRightImg from "../../../picture/NextLanguage.png";
import NavbarDocuments from "./NavbarDocuments";
import ShowBarEvidencije from "../Showbar/Documents/ShowBarEvidencije";
import useIsOpening from "../../../Context/hooks/useIsOpening";

function Navbar({
  setIsCardActive,
  showList,
  setShowList,
  currentTab,
  setCurrentTab,
  setSelectedItem,
  selectedItem,
  timeUnlockCurrent,
  companies,
  setSelectAccount,
  isOpening, // <-- novo
  openingType,
}) {
  const buttonPictureActive = picture12;
  const buttonPictureNonActive = picture13;

  const listLocation = [
    "AKTIVNOSTI",
    "PODESAVANJA",
    "DODAVANJE KORISNIKA",
    "TEMPLATE IZVESTAJA",
    "FOLDER DOKUMENATA",
    "STATISTIKA LOKACIJE",
  ];

  const listUser = [
    "OPSTA PODESAVANJA",
    "PRIVILEGIJE PO LOKACIJAMA",
    "STATISTIKA",
  ];

  const navbarButton = [
    { name: "USER", picture: picture0, active: 0 },
    { name: "HOME", picture: picture1, active: 0 },
    { name: "SETTINGS", picture: picture2, active: 0 },
    { name: "LOKACIJE", picture: picture0, active: 0 },
    { name: "KORISNICI", picture: picture0, active: 0 },
  ];

  const settings = [
    { name: "INICIJALNA PODESAVANJA" },
    { name: "STIL PANELA" },
    { name: "UPOTREBA SKLADISTA" },
    { name: "DEFINISANJE MODERATORA" },
    { name: "KORISCENJE APLIKACIJE" },
    { name: "WEB PREZENTACIJA" },
  ];

  const {
    activeIcons,
    setActiveIcons,
    setActiveStates,
    chooseObject,
    setChooseObject,
    setSelectedNavbarDocument,
    selectedNavbarDocument,
    setSelectedEvidencija,
    selectedEvidencija,
    setSelectedCompany,
    selectedCompany,
    selectedAccount,
    setSelectedAccount,
    isShowAccounts,
    setIsShowAccounts,
  } = useGlobalContext();
  const { baseUrl } = useGlobalContext();
  const { loggedUser, apiKey, setIsSelectedZaposleni, isSelectedZaposleni } =
    useGlobalContext();
  const setCurrentCounter = () => {
    if (selectedCompany === null) return 0;
    else if (activeIcons.length === 0) return 1;
    else return 2;
  };

  const [showSettings, setShowSettings] = useState(false);

  const [counter, setCounter] = useState(setCurrentCounter());

  const [clickLocationNavbar, setClickLocationNavbar] = useState({
    index: 0,
    value: false,
  });

  const [clickUserNavbar, setClickUserNavbar] = useState({
    index: 0,
    value: false,
  });

  const [isDocumentNavbar, setIsDocumentNavbar] = useState(false);

  // sluzi da cuva trenutno selektovanog korisnika/lokaciju

  const handleData = (item, index, i) => {
    console.log(item, index, i);
    let wraperProfile = document.querySelector(
      ".wraper-user-location-choose-object",
    );
    if (wraperProfile === null) {
      wraperProfile = document.querySelector(".wraper-user-location");
    }
    console.log(wraperProfile);
    if (wraperProfile) {
      const buttonPictureDim = document
        .querySelector(".button-taskbar")
        .getBoundingClientRect();
      const buttonCompanyDim = document
        .querySelector(".button-taskbar")
        .getBoundingClientRect();
      console.log(buttonPictureDim);
      console.log(buttonCompanyDim);
      console.log(wraperProfile, chooseObject);

      wraperProfile.style.height = "calc(100vw / 11)";
    }
    setChooseObject({
      data: item.name,
      index,
      currentIndex: i !== undefined ? i : 0,
      id: index === 3 ? parseInt(item.location_id) : parseInt(item.user_id),
    });
  };

  const handleBack = () => {
    setChooseObject(null);
    setClickLocationNavbar({
      index: 0,
      value: false,
    });
    setClickUserNavbar({
      index: 0,
      value: false,
    });
    const wraperProfile = document.querySelector(
      ".wraper-user-location-choose-object",
    );
    if (wraperProfile) {
      const buttonPictureDim = document
        .querySelector(".button-taskbar")
        .getBoundingClientRect();
      const buttonCompanyDim = document
        .querySelector(".button-taskbar")
        .getBoundingClientRect();
      console.log(buttonPictureDim);
      console.log(buttonCompanyDim);
      console.log(wraperProfile, chooseObject);

      wraperProfile.style.height = "calc(100vw / 11)";
    }
  };

  const checkObject = () => {
    return chooseObject.index === 3;
  };

  const handleActiveLocationNavbar = () => {
    setClickLocationNavbar({
      index: 0,
      value: !clickLocationNavbar.value,
    });
  };

  const handleActiveUserNavbar = () => {
    setClickUserNavbar({
      index: 0,
      value: !clickUserNavbar.value,
    });
  };

  useEffect(() => {
    if (isOpening) {
      setIsDocumentNavbar(true);
    }
  }, [isOpening]);

  const handleSelectCompany = async (company) => {
    // if (selectedCompany?.company_name === company.company_name) {
    // setSelectedCompany(null);
    // } else {
    // api call za naloge ukoliko ih ima
    try {
      const { data } = await axios.post(
        `${baseUrl}/admin_panel/companies/readByCompanyId.php`,
        {
          user_id: loggedUser.id,
          api_key: apiKey,
          company_id: company.company_id,
        },
      );
      console.log(data);
      if (data.status === 200) {
        setSelectedCompany(data.data[0]);
        /* setChooseObject({
            data: data.data[0].locations[0].name,
            index: 3,
            currentIndex: 1,
            id: data.data[0].locations[0].location_id,
          });*/

        console.log("Selektovanje kompanije", data.data[0], {
          data: data.data[0].locations[0].name,
          index: 3,
          currentIndex: 1,
          id: parseInt(data.data[0].locations[0].location_id),
        });
        const wraperProfile = document.querySelector(
          ".wraper-user-location-choose-object",
        );
        console.log("Provera" + wraperProfile);
        if (wraperProfile) {
          const buttonPictureDim = document
            .querySelector(".button-taskbar")
            .getBoundingClientRect();
          const buttonCompanyDim = document
            .querySelector(".button-picture")
            .getBoundingClientRect();

          wraperProfile.style.height = `${buttonCompanyDim.height}px`;
        }
      }
    } catch (e) {
      console.log(e);
      if (e.status === 404) {
      }
    }
    // }
  };

  const handleSelectAccount = async (company) => {
    if (selectedAccount?.company_name === company.company_name)
      setSelectedAccount(null);
    else {
      try {
        const { data } = await axios.post(
          `${baseUrl}/admin_panel/companies/readAccountById.php`,
          {
            company_id: company.company_id,
            user_id: loggedUser.id,
            api_key: apiKey,
          },
        );
        console.log(data);
        if (data.status === 200) {
          setSelectedAccount(data.data[0]);
          const wraperProfile = document.querySelector(
            ".wraper-user-location-choose-object",
          );
          console.log("Provera" + wraperProfile);
          if (wraperProfile) {
            const buttonPictureDim = document
              .querySelector(".button-taskbar")
              .getBoundingClientRect();
            const buttonCompanyDim = document
              .querySelector(".button-picture")
              .getBoundingClientRect();
            console.log(buttonPictureDim);
            console.log(buttonCompanyDim);
            console.log(wraperProfile, chooseObject);

            wraperProfile.style.height = `${buttonCompanyDim.height}px`;
          }
          console.log("Selektovanje account", data);
        }
      } catch (error) {
        if (error.status === 404) {
          console.log(error);
        }
      }
    }
  };

  const handleScrollTop = (indexNonActive, indexActive) => {
    const wraperCompanies = document.querySelector(".wraper-companies");
    const buttonTaskbar = document.querySelectorAll(".button-taskbar-wrapper")[
      indexNonActive
    ];
    wraperCompanies.scrollTo(
      0,
      indexActive * buttonTaskbar?.getBoundingClientRect().height,
    );
  };

  const handleLogoClick = () => {
    if (counter === 2) {
      setCurrentTab(null);
      setCounter(1);
      //setActiveStates([]);
    } else if (counter === 1) {
      setCurrentTab(null);
      setActiveIcons([]);
      setSelectedCompany(null);
      setSelectedAccount(null);
      const wraperCompanies = document.querySelector(".wraper-companies");
      wraperCompanies.scrollTo(0, 0);
      setCounter(0);
      setChooseObject(null);
    }
  };

  const renderShowbar = (element) => {
    return (
      <ShowBar setSelectedItem={setSelectedItem} selectedItem={selectedItem} />
    );
  };

  const handleClickSettings = () => {
    setShowSettings(!showSettings);
  };

  const handleSelectProfile = () => {
    if (isShowAccounts) {
      setIsShowAccounts(false);
      setSelectedAccount(null);
      if (selectedNavbarDocument !== "") setSelectedNavbarDocument("");
      if (selectedEvidencija !== 0) setSelectedEvidencija(0);
      return;
    }

    const editorUser = localStorage.getItem("editor-user");
    const apiKey = localStorage.getItem("api-key");
    const params = new URLSearchParams({
      "editor-user": editorUser,
      "api-key": apiKey,
    });
    window.location.href = `https://app.nadzor.app?${params.toString()}`;
  };

  useEffect(() => {
    if (selectedAccount !== null) {
      const indexCurrent =
        selectedCompany.accounts
          .map((company) => company.company_name)
          .indexOf(selectedAccount.company_name) + 1;
      let indexNonActive;
      if (indexCurrent === selectedCompany.accounts.length) {
        indexNonActive = indexCurrent - 1;
      } else {
        indexNonActive = indexCurrent + 1;
      }
      handleScrollTop(indexNonActive, indexCurrent);
    }
    setChooseObject(null);
    setClickLocationNavbar({
      index: 0,
      value: false,
    });
    setClickUserNavbar({
      index: 0,
      value: false,
    });
    if (currentTab !== null) setCounter(2);
    /*if (counter > 0 && activeIcons.length === 0) {
      setCounter(1);
    }*/
  }, [selectedAccount, activeIcons, currentTab]);

  useEffect(() => {
    if (selectedCompany !== null) {
      setCounter(1);
      setIsCardActive(true);
      setShowList(selectedCompany.accounts);
    } else {
      setShowList(companies);
      setIsCardActive(false);
      setCounter(0);
    }
    setChooseObject(null);
    setClickLocationNavbar({
      index: 0,
      value: false,
    });
    setClickUserNavbar({
      index: 0,
      value: false,
    });
  }, [selectedCompany]);

  const setDimensions = () => {
    const buttonPicture = document.querySelector(".button-taskbar");
    if (buttonPicture) {
      const buttonPictureDim = buttonPicture.getBoundingClientRect();
      const wrapperProfile = document.querySelector(".wraper-all");
      // wrapperProfile.style.height = `70px`;
      const taskbar = document
        .querySelector(".task-bar")
        .getBoundingClientRect();
      const wrapperCompanies = document.querySelector(".wraper-companies");
      // wrapperCompanies.style.height = `${taskbar.height}px`;
      // wrapperCompanies.style.width = `${buttonPictureDim.width * 2}px`;
    }
  };

  const handleClickArrow = () => {
    setSelectedNavbarDocument("");
    setIsDocumentNavbar((prev) => !prev);
    setIsSelectedZaposleni(false);
  };

  console.log("Ovo je chooseObject", chooseObject);
  window.addEventListener("resize", setDimensions);

  useEffect(() => {
    setDimensions();
  }, []);

  return (
    <div className="wraper-all">
      <div className="wraper-profile">
        <WraperCustom
          width="50%"
          list={showList}
          selected1={selectedCompany}
          selected2={selectedAccount}
          handleSelected1={handleSelectCompany}
          handleSelected2={handleSelectAccount}
          renderComponent={() => renderShowbar()}
          isShowAccounts={isShowAccounts}
          setIsShowAccounts={setIsShowAccounts}
          isOpening={isOpening} // <-- da li ovo postoji?
          openingType={openingType}
        />
        <div
          className="button-navbar"
          onClick={isOpening ? undefined : handleClickArrow}
        >
          <Button activation={true}>
            <img
              src={arrowRightImg}
              style={{ transform: isDocumentNavbar ? "rotate(180deg)" : "" }}
            />
          </Button>
        </div>
        <div className="button-navbar" onClick={() => handleSelectProfile()}>
          <Button activation={true}>
            <img src={backImg} />
          </Button>
        </div>
      </div>
      {isDocumentNavbar ? (
        <div style={{ pointerEvents: isOpening ? "none" : "auto" }}>
          <NavbarDocuments setIsDocumentNavbar={setIsDocumentNavbar} />
        </div>
      ) : (
        <div
          className={
            chooseObject === null
              ? "wraper-user-location"
              : "wraper-user-location-choose-object"
          }
        >
          {selectedCompany ? (
            <>
              {chooseObject === null ? (
                <>
                  <CustomButton
                    handleData={handleData}
                    buttonPictureActive={buttonPictureActive}
                    navbarButton={navbarButton}
                    buttonPictureNonActive={buttonPictureNonActive}
                    data={
                      selectedAccount !== null
                        ? selectedAccount.locations
                        : selectedCompany.locations
                    }
                    handleActiveNavbar={handleActiveLocationNavbar}
                    clickNavbar={clickLocationNavbar}
                    isBothMinimize={
                      !clickLocationNavbar.value && !clickUserNavbar.value
                    }
                    timeUnlockCurrent={timeUnlockCurrent}
                    index={3} //3 oznacava poziciju elementa u navbaru
                  />
                  {/* <CustomButton
                    handleData={handleData}
                    buttonPictureActive={buttonPictureActive}
                    navbarButton={navbarButton}
                    buttonPictureNonActive={buttonPictureNonActive}
                    data={
                      selectedAccount !== null
                        ? selectedAccount.users
                        : selectedCompany.users
                    }
                    handleActiveNavbar={handleActiveUserNavbar}
                    isBothMinimize={
                      !clickLocationNavbar.value && !clickUserNavbar.value
                    }
                    clickNavbar={clickUserNavbar}
                    timeUnlockCurrent={timeUnlockCurrent}
                    index={4} //4 oznacava poziciju elementa u navbaru
                  /> */}
                  <div
                    onClick={() => setIsSelectedZaposleni((prev) => !prev)}
                    className="button-navbar"
                  >
                    <Button active={isSelectedZaposleni}>
                      <span style={{ fontSize: "4.5vh", fontWeight: 600 }}>
                        ЗАПОСЛЕНИ
                      </span>
                    </Button>
                  </div>
                </>
              ) : (
                <SelectedNavbar
                  currentIndex={chooseObject.currentIndex}
                  chooseObject={chooseObject}
                  setChooseObject={setChooseObject}
                  handleBack={handleBack}
                  buttonPictureNonActive={buttonPictureNonActive}
                  list={checkObject() ? listLocation : listUser}
                  data={
                    selectedAccount !== null
                      ? chooseObject.index === 3
                        ? selectedAccount.locations
                        : selectedAccount.users
                      : chooseObject.index === 3
                        ? selectedCompany.locations
                        : selectedCompany.users
                  }
                />
              )}{" "}
            </>
          ) : (
            <>
              <div className="button-navbar" style={{ pointerEvents: "none" }}>
                <Button active={false} />
              </div>
              <div className="button-navbar" style={{ pointerEvents: "none" }}>
                <Button active={false} />
              </div>
            </>
          )}
        </div>
      )}
    </div>
  );
}

export default Navbar;
